export default __webpack_public_path__ + "static/media/bundle-guide-me-us@3x.6bac5295.jpg";